import { MenuItem } from "./menuTypes";

export const filterMenu = (items: MenuItem[], allowedUrls: string[]): MenuItem[] => {
  return items
    .map(item => {
      // Se tem filhos → filtra recursivamente
      if (item.children) {
        const filteredChildren = filterMenu(item.children, allowedUrls);

        // Se restaram filhos, mantém o item
        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        }

        // Se o item tem URL próprio → valida permissão
        if (item.url && allowedUrls.includes(item.url)) {
          return item;
        }

        return null;
      }

      // Links externos SEMPRE ficam
      if (item.blank) {
        return item;
      }

      // Itens simples → valida permissão
      if (item.url && allowedUrls.includes(item.url)) {
        return item;
      }

      return null;
    })
    .filter(Boolean) as MenuItem[];
};
